module.exports = __webpack_public_path__ + "img/y-5.20c934b3.png";